import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

import {
  displayTeamCharge,
  teamChargeLabel,
  deliveryFeeLabel,
  eliteEatsPayoutMainLabel,
  eliteEatsPayoutSubLabel,
  restaurantPayoutMainLabel,
  restaurantPayoutSubLabel
} from '../../constants/global';

import { useFormatData } from '../Hooks/useFormatData';

// Font.register({
//   family: 'Times-Roman',
// });

const styles = StyleSheet.create({
  page: {
    fontSize: '12px',
    fontFamily: 'Times-Roman',
    paddingBottom: '40px',
  },
  eliteEatsSection: {
    flexDirection: 'row',
    gap: '10px',
    padding: '10px',
    alignItems: 'baseline',
  },
  eliteEats: {
    fontSize: '16px',
  },
  eliteEatsWebsite: {
    fontSize: '12px',
    paddingBottom: '1px',
  },
  sideBySideSection: {
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'space-between',
  },
  section: {
    // margin: 10,
    padding: 10,
    // flexGrow: 1,
  },
  subSection: {
    marginBottom: 10,
  },
  header: {
    // borderBottom: '1px solid #EEE',
    marginBottom: 10,
  },
  footer: {
    textAlign: 'center',
    fontSize: '10px',
  },
  headerText: {
    fontSize: '10px',
    fontFamily: 'Times-Bold',
    paddingBottom: 5,
  },
  table: {
    width: '100%',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid #EEE',
    // paddingTop: 8,
    // paddingBottom: 8,
    padding: 8,
  },
  smallrow: {
    display: 'flex',
    flexDirection: 'row',
    // padding: 8,
    // paddingTop: 2,
    paddingRight: 4,
    paddingBottom: 8,
  },
  smallrowNoBottomPadding: {
    display: 'flex',
    flexDirection: 'row',
    paddingRight: 4,
  },
  headerRow: {
    borderTop: 'none',
    // border: '1px solid red',
    fontFamily: 'Times-Bold',
  },
  orderItemsHolder: {
    // border: '1px solid red',
    marginBottom: '40px',
  },
  additionalChargesHolder: {
    // border: '1px solid red',
    marginBottom: '20px',
  },
  subHeader: {
    fontFamily: 'Times-Bold',
    // borderTop: 'none',
    textAlign: 'center',
    width: '100%',
    // paddingTop: '30px',
    // borderTop: '2px solid #EEE',
    // paddingTop: '30px',
  },
  subtotal: {
    fontFamily: 'Times-Bold',
    fontSize: '12px',
    borderTop: 'none',
  },
  subtotalNoTopBorder: {
    fontFamily: 'Times-Bold',
    fontSize: '12px',
    borderTop: 'none',
  },
  total: {
    fontFamily: 'Times-Bold',
    fontSize: '14px',
    borderTop: '2px solid #EEE',
  },
  totalNoTopBorder: {
    fontFamily: 'Times-Bold',
    fontSize: '14px',
    borderTop: 'none',
  },
  orderend: {
    borderTop: '2px solid #EEE',
    paddingTop: '20px',
  },
  bold: {
    fontFamily: 'Times-Bold',
  },
  smalltext: {
    paddingTop: '2px',
    fontSize: '10px',
    // verticalAlign: 'bottom',
  },
  column1: {
    width: '10%',
    textAlign: 'right',
    paddingRight: '20px',
  },
  column2: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  column3: {
    width: '15%',
    textAlign: 'right',
    paddingRight: '20px',
  },
  column4: {
    width: '15%',
    textAlign: 'right',
  },
  column3wide: {
    width: '85%',
    textAlign: 'right',
    paddingRight: '20px',
  },
  rowFull: {
    width: '100%',
    textAlign: 'right',
  },
  itemName: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    flexWrap: 'wrap',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    fontSize: '10px',
  },
  topPadding: {
    paddingTop: '20px',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: '10px',
    bottom: '10px',
    left: 0,
    right: 0,
    textAlign: 'center',
  },
});

const PdfOrderDetails = (props) => {
  const {
    deliveryDateAndTimeForDisplay,
    deliveryLocationForDisplay,
    recordDetails,
    orderContacts,
    orderItems,
    additionalCharges,
    selectedRestaurant,
    userRole,
  } = props;

  // recordDetails.subtotal = null;
  // recordDetails.tax = null;
  // recordDetails.teamCharge = null;
  // recordDetails.total = null;

  // console.log('##### PdfOrderDetails - recordDetails #####', recordDetails);
  // console.log('orderItems', orderItems);

  const { FormatCurrencyForDisplay } = useFormatData();

  const showDeliveryInstructions = false;
  const showTeamInstructions = false;
  const showTeamContact = false;
  const showRestaurantPhoneNumber = true;
  const showRestaurantEmail = true;
  const showAdditionalChargesHeader = true;
  const showDescription = false;
  const showDetails = false;

  const orderNumber = recordDetails ? recordDetails.orderNumber : '';
  const orderStatus = recordDetails ? recordDetails.overallOrderStatus : '';

  let showTeamCharge = displayTeamCharge ? displayTeamCharge : false;
  let showTax = false;
  let showTotal = true;

  if (
    recordDetails.restaurantStatus === 'Scheduled' ||
    recordDetails.restaurantStatus === 'Completed'
  ) {
    showTeamCharge = true;
    showTax = true;
    showTotal = true;
  } else {
    showTax = false;
    showTotal = false;
  }

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.header} fixed>

            <View style={styles.eliteEatsSection}>
              <Text style={styles.eliteEats}>Elite Eats Inc.</Text>
              <Text style={styles.eliteEatsWebsite}>www.elite-eats.com</Text>
            </View>

          <View style={styles.sideBySideSection}>
            <View style={styles.section}>
              <Text style={styles.headerText}>Delivery Date</Text>
              {deliveryDateAndTimeForDisplay ? <Text>{deliveryDateAndTimeForDisplay}</Text> : null}
            </View>

            <View style={styles.section}>
              <Text style={styles.headerText}>Order Number</Text>
              {orderNumber ? <Text>{orderNumber}</Text> : null}
            </View>

            <View style={styles.section}>
              <Text style={styles.headerText}>Order Status</Text>
              {orderStatus ? <Text>{orderStatus}</Text> : null}
            </View>
          </View>

          <View style={styles.sideBySideSection}>
            <View style={styles.section}>
              <Text style={styles.headerText}>Delivery Address</Text>
              {recordDetails ? <Text>{recordDetails.teamName}</Text> : null}

              {deliveryLocationForDisplay ? (
                <>
                  <Text>{deliveryLocationForDisplay.name}</Text>
                  <Text>{deliveryLocationForDisplay.addressLine1}</Text>
                  <Text>{deliveryLocationForDisplay.addressLine2}</Text>
                </>
              ) : null}
            </View>

            <View style={styles.section}>
              <Text style={styles.headerText}>Restaurant</Text>
              {selectedRestaurant ? <Text>{selectedRestaurant.name}</Text> : null}

              {selectedRestaurant ? (
                <>
                {orderStatus === 'Draft' ? (
                  <>
                  <Text>
                    {selectedRestaurant.city +
                      ', ' +
                      selectedRestaurant.state}
                  </Text>
                  </>
                ) : (
                  <>
                    <Text>{selectedRestaurant.address}</Text>
                    <Text>
                      {selectedRestaurant.city +
                        ', ' +
                        selectedRestaurant.state +
                        ', ' +
                        selectedRestaurant.zipcode}
                    </Text>
                    {showRestaurantPhoneNumber ? <Text>{selectedRestaurant.phone}</Text> : null}
                    {showRestaurantEmail ? <Text>{selectedRestaurant.email}</Text> : null}
                  </>
                )}


                </>
              ) : null}
            </View>

            {showTeamContact ? (
              <>
                {Array.isArray(orderContacts) && orderContacts.length > 0 ? (
                  <View style={styles.section}>
                    <Text style={styles.headerText}>
                      {orderContacts.length === 1 ? 'Contact' : 'Contacts'}
                    </Text>

                    {orderContacts.map((record, index) => (
                      <View style={styles.subSection} key={index}>
                        <Text>{record.name}</Text>
                        <Text>{record.position}</Text>
                        <Text>{record.phone}</Text>
                        <Text>{record.email}</Text>
                      </View>
                    ))}
                  </View>
                ) : null}
              </>
            ) : null}
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.table}>
            <View style={[styles.row, styles.bold, styles.headerRow]}>
              <Text style={styles.column1}>Qty</Text>
              <Text style={styles.column2}>Item</Text>
              <Text style={styles.column3}>Price</Text>
              <Text style={styles.column4}>Subtotal</Text>
            </View>

            {Array.isArray(orderItems) && orderItems.length > 0 ? (
              <View style={styles.orderItemsHolder} wrap={true}>
                {orderItems.map((row, i) => (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={styles.column1}>{row.quantity}</Text>

                    <View style={styles.column2}>
                      <View style={styles.itemName}>
                        <Text>{row.name}</Text>
                      </View>

                      {row.feeds ? (
                        <View style={styles.listItem}>
                          <Text style={styles.smalltext}>
                            {row.servingSize && row.priceDetails
                              ? '(Feeds ' + row.feeds + ' - ' + row.servingSize + ' - ' + row.priceDetails + ') '
                              : row.servingSize 
                              ? '(Feeds ' + row.feeds + ' - ' + row.servingSize + ') ' 
                              : row.priceDetails
                              ? '(Feeds ' + row.feeds + ' - ' + row.priceDetails + ') '
                              : '(Feeds ' + row.feeds + ')'}
                          </Text>
                        </View>
                      ) : null}

                      {showDescription & row.description ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.description}</Text>
                        </View>
                      ) : null}

                      {showDetails && row.details ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.details}</Text>
                        </View>
                      ) : null}

                      {row.specialInstructions ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.specialInstructions}</Text>
                        </View>
                      ) : null}
                    </View>
                    <Text style={styles.column3}>{FormatCurrencyForDisplay(row.price)}</Text>
                    <Text style={styles.column4}>{FormatCurrencyForDisplay(row.subtotal)}</Text>
                  </View>
                ))}
              </View>
            ) : null}

            {Array.isArray(additionalCharges) && additionalCharges.length > 0 ? (
              <View style={styles.additionalChargesHolder}>
                {showAdditionalChargesHeader ? (
                  <View style={[styles.smallrow, styles.subHeader]}>
                    <Text>Additional Charges</Text>
                  </View>
                ) : null}

                {additionalCharges.map((row, i) => (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={styles.column1}>{row.quantity}</Text>
                    {/* <Text style={styles.column2}>{row.name}</Text> */}
                    <View style={styles.column2}>
                      <Text style={styles.column2}>{row.name}</Text>
                      {row.description ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.description}</Text>
                        </View>
                      ) : null}
                    </View>
                    <Text style={styles.column3}>{FormatCurrencyForDisplay(row.price)}</Text>
                    <Text style={styles.column4}>{FormatCurrencyForDisplay(row.subtotal)}</Text>
                  </View>
                ))}
              </View>
            ) : null}

            <View style={styles.sectionTotals} wrap={false}>
              {recordDetails.subtotalFormatted !== null &&
              recordDetails.subtotalFormatted !== 0 &&
              recordDetails.subtotalFormatted !== '' ? (
                <View style={[styles.row, styles.subtotal, styles.orderend]} wrap={false}>
                  <Text style={styles.column3wide}>Subtotal</Text>
                  <Text style={styles.column4}>{recordDetails.subtotalFormatted}</Text>
                </View>
              ) : null}

              {showTeamCharge &&
              recordDetails.teamChargeFormatted !== null &&
              recordDetails.teamChargeFormatted !== 0 &&
              recordDetails.teamChargeFormatted !== '' ? (
                <View style={[styles.row, styles.subtotal]} wrap={false}>
                  <Text style={styles.column3wide}>{teamChargeLabel}</Text>
                  <Text style={styles.column4}>{recordDetails.teamChargeFormatted}</Text>
                </View>
              ) : null}

              {recordDetails.deliveryFeeFormatted !== null &&
              recordDetails.deliveryFeeFormatted !== 0 &&
              recordDetails.deliveryFeeFormatted !== '$0.00' &&
              recordDetails.deliveryFeeFormatted !== '' ? (
                <View style={[styles.row, styles.subtotal]} wrap={false}>
                  <Text style={styles.column3wide}>{deliveryFeeLabel}</Text>
                  <Text style={styles.column4}>{recordDetails.deliveryFeeFormatted}</Text>
                </View>
              ) : null}

              {recordDetails.tipFormatted !== null &&
              recordDetails.tipFormatted !== 0 &&
              recordDetails.tipFormatted !== '' ? (
                <View style={[styles.row, styles.subtotal]} wrap={false}>
                  <Text style={styles.column3wide}>Gratuity (for the driver)</Text>
                  <Text style={styles.column4}>{recordDetails.tipFormatted}</Text>
                </View>
              ) : null}

              {showTax &&
              recordDetails.taxFormatted !== null &&
              recordDetails.taxFormatted !== 0 &&
              recordDetails.taxFormatted !== '' ? (
                <View style={[styles.row, styles.subtotal]} wrap={false}>
                  <Text style={styles.column3wide}>Sales Tax *</Text>
                  <Text style={styles.column4}>{recordDetails.taxFormatted}</Text>
                </View>
              ) : null}

              {showTotal &&
              recordDetails.calculatedTotalFormatted !== null &&
              recordDetails.calculatedTotalFormatted !== 0 &&
              recordDetails.calculatedTotalFormatted !== '' ? (
                <View style={[styles.row, styles.total]} wrap={false}>
                  <Text style={styles.column3wide}>Order Total</Text>
                  <Text style={styles.column4}>{recordDetails.calculatedTotalFormatted}</Text>
                </View>
              ) : null}

              {userRole === 'Vendor' &&
              recordDetails.eliteEatsCutFormatted !== null &&
              recordDetails.eliteEatsCutFormatted !== 0 &&
              recordDetails.eliteEatsCutFormatted !== '' ? (
                <>
                  <View style={[styles.row, styles.subtotal]} wrap={false}>
                    <Text style={styles.column3wide}>{eliteEatsPayoutMainLabel}</Text>
                    <Text style={styles.column4}>{recordDetails.eliteEatsCutFormatted}</Text>
                  </View>

                  <View style={[styles.smallrow, styles.smalltext]} wrap={false}>
                    <Text style={styles.column3wide}>{eliteEatsPayoutSubLabel}</Text>
                    <Text style={styles.column4}></Text>
                  </View>
                </>
              ) : null}

              {userRole === 'Vendor' &&
              recordDetails.restaurantsCutFormatted !== null &&
              recordDetails.restaurantsCutFormatted !== 0 &&
              recordDetails.restaurantsCutFormatted !== '' ? (
                <>
                  <View style={[styles.row, styles.total]} wrap={false}>
                    <Text style={styles.column3wide}>Payout Amount</Text>
                    <Text style={styles.column4}>{recordDetails.restaurantsCutFormatted}</Text>
                  </View>

                  <View style={[styles.smallrow, styles.smalltext]} wrap={false}>
                    <Text style={styles.column3wide}>{restaurantPayoutSubLabel}</Text>
                    <Text style={styles.column4}></Text>
                  </View>
                </>
              ) : null}

              {userRole === 'Admin' ? (
                <>
                  {recordDetails.restaurantsCutFormatted !== null &&
                  recordDetails.restaurantsCutFormatted !== 0 &&
                  recordDetails.restaurantsCutFormatted !== '' ? (
                    <>
                      <View style={[styles.row, styles.subtotal]} wrap={false}>
                        <Text style={styles.column3wide}>{restaurantPayoutMainLabel}</Text>
                        <Text style={styles.column4}>{recordDetails.restaurantsCutFormatted}</Text>
                      </View>

                      <View style={[styles.smallrow, styles.smalltext]} wrap={false}>
                        <Text style={styles.column3wide}>{restaurantPayoutSubLabel}</Text>
                        <Text style={styles.column4}></Text>
                      </View>
                    </>
                  ) : null}

                  {recordDetails.eliteEatsCutFormatted !== null &&
                  recordDetails.eliteEatsCutFormatted !== 0 &&
                  recordDetails.eliteEatsCutFormatted !== '' ? (
                    <>
                      <View style={[styles.row, styles.totalNoTopBorder]} wrap={false}>
                        <Text style={styles.column3wide}>{eliteEatsPayoutMainLabel}</Text>
                        <Text style={styles.column4}>{recordDetails.eliteEatsCutFormatted}</Text>
                      </View>

                      <View style={[styles.smallrow, styles.smalltext]} wrap={false}>
                        <Text style={styles.column3wide}>{eliteEatsPayoutSubLabel}</Text>
                        <Text style={styles.column4}></Text>
                      </View>
                    </>
                  ) : null}
                </>
              ) : null}

              {recordDetails.taxFormatted === null ||
              recordDetails.taxFormatted === 0 ||
              recordDetails.taxFormatted === '' ? (
                <View style={[styles.row, styles.smalltext, styles.topPadding]} wrap={false}>
                  <Text style={styles.rowFull}>* Sales Tax will be calculated at payment</Text>
                </View>
              ) : null}

              {/* {showTotal &&
            recordDetails.totalFormatted !== null &&
            recordDetails.totalFormatted !== 0 &&
            recordDetails.totalFormatted !== '' ? (
              <View style={[styles.row, styles.total]} wrap={false}>
                <Text style={styles.column3wide}>Total</Text>
                <Text style={styles.column4}>{recordDetails.totalFormatted}</Text>
              </View>
            ) : null} */}
            </View>
          </View>
        </View>

        {showDeliveryInstructions ? (
          <View style={styles.section}>
            <Text style={styles.headerText}>Delivery Instructions</Text>
            {recordDetails ? <Text>{recordDetails.deliveryInstructions}</Text> : null}
          </View>
        ) : null}

        {showTeamInstructions ? (
          <View style={styles.section}>
            <Text style={styles.headerText}>Team Instructions</Text>
            {recordDetails ? <Text>{recordDetails.teamInstructions}</Text> : null}
          </View>
        ) : null}

        <View
          style={styles.pageNumber}
          render={({ totalPages }) =>
            totalPages > 1 && (
              <Text
                style={styles.footer}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
              />
            )
          }
          fixed
        />

        {/* <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        /> */}
      </Page>
    </Document>
  );
};

export default PdfOrderDetails;
